var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangesettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.978,
    height: 29.986,
    viewBox: "0 0 29.978 29.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M32,19.489a3.858,3.858,0,0,1,2.475-3.6,15.291,15.291,0,0,0-1.85-4.458,3.909,3.909,0,0,1-1.569.336A3.849,3.849,0,0,1,27.538,6.35a15.244,15.244,0,0,0-4.45-1.85,3.854,3.854,0,0,1-7.2,0,15.291,15.291,0,0,0-4.458,1.85,3.849,3.849,0,0,1-3.521,5.418,3.782,3.782,0,0,1-1.569-.336A15.629,15.629,0,0,0,4.5,15.9a3.856,3.856,0,0,1,.008,7.2,15.291,15.291,0,0,0,1.85,4.458,3.851,3.851,0,0,1,5.082,5.082,15.38,15.38,0,0,0,4.458,1.85,3.847,3.847,0,0,1,7.182,0,15.291,15.291,0,0,0,4.458-1.85,3.854,3.854,0,0,1,5.082-5.082A15.38,15.38,0,0,0,34.47,23.1,3.876,3.876,0,0,1,32,19.489ZM19.559,25.726A6.245,6.245,0,1,1,25.8,19.481,6.244,6.244,0,0,1,19.559,25.726Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#ec6321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangesettings);
export default __webpack_public_path__ + "static/media/orangesettings.0d9ade1f1beaf58c32de4b6161ee2c30.svg";
export { ForwardRef as ReactComponent };